import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tip",
  "use": "icon-tip-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tip\"><path d=\"M512 992c-60.8 0-108.8-41.6-124.8-96H160c-25.6 0-44.8-9.6-57.6-28.8-16-25.6-12.8-57.6 3.2-92.8 3.2-3.2 3.2-6.4 6.4-9.6L192 691.2V416c0-134.4 83.2-252.8 208-300.8C406.4 67.2 454.4 32 512 32s105.6 35.2 112 83.2C748.8 163.2 832 281.6 832 416v275.2l80 73.6c3.2 3.2 6.4 6.4 6.4 9.6 16 35.2 19.2 67.2 3.2 92.8-12.8 19.2-32 28.8-57.6 28.8h-227.2c-16 54.4-64 96-124.8 96z m-54.4-96c9.6 19.2 32 32 54.4 32s44.8-12.8 54.4-32h-108.8z m409.6-64s3.2-9.6-3.2-25.6l-86.4-80c-6.4-6.4-9.6-12.8-9.6-22.4v-288c0-115.2-76.8-214.4-185.6-246.4-16-3.2-25.6-22.4-22.4-38.4V128c0-16-22.4-32-48-32s-48 16-48 32v3.2c3.2 16-6.4 32-22.4 38.4C332.8 201.6 256 300.8 256 416v288c0 9.6-3.2 16-9.6 22.4L160 806.4c-6.4 12.8-6.4 22.4-3.2 25.6h710.4z\" p-id=\"2021\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tip.svg
// module id = 6+87
// module chunks = 42